import React, { useRef, useState, useEffect, useCallback } from "react";
import Short from "./Short";

function DisablePostMessage() {
  useEffect(() => {
    window.postMessage = function() {
    };
  }, []); 

  return null; 
}


function ShortContainer({ path }) {
  const shortContainerRef = useRef();
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1); // Current page
  const [loading, setLoading] = useState(false); // Loading state
  const [hasMore, setHasMore] = useState(true); // Whether there are more items to load
  const [oldPath, setOldPath] = useState(null);

  const fetchData = async (path, pageSize, page) => {
    try {
      setLoading(true);
      const response = await fetch(`https://www.m-arabi.com/apis/get_shorts.php?path=${path}&limit=${pageSize}&page=${page}`);
      if (!response.ok) {
        throw new Error("Failed to fetch data from API");
      }
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error(error);
      return null;
    } finally {
      setLoading(false);
    }
  };

  const loadData = useCallback(async () => {
      if (!path || path === '') {
        path = 'all';
      }
      if (path === 'all') {
        path = '';
      }
    const jsonResponse = await fetchData(path, 20, page);
    if (jsonResponse && jsonResponse.data) {
      const jsonData = jsonResponse.data;
      setData((prevData) => [...prevData, ...jsonData]); // Append fetched data to existing data
      setHasMore(jsonResponse.totalRows - (20 * page) > 0); // Update hasMore based on whether there are more items
      console.log("Success to fetch data from API");
	  console.log("page " +page);
		
    } else {
      console.log("Failed to fetch data from API");
    }
  }, [path, page]);

  useEffect(() => {
    if (oldPath !== path) {
      setData([]);
      setOldPath(path);
    }
	if(!loading){
    	loadData();
	}
  }, [loadData, oldPath, path]);

  const handleScroll = useCallback(() => {
    if (
      shortContainerRef.current &&
      shortContainerRef.current.scrollTop + shortContainerRef.current.clientHeight >=
      shortContainerRef.current.scrollHeight &&
      !loading &&
      hasMore
    ) {
      //setLoading(true);
      setPage((prevPage) => prevPage + 1); // Load next page
      console.log('handleScroll');
    }
  }, [loading, hasMore]);

  useEffect(() => {
    if (shortContainerRef.current) {
      shortContainerRef.current.addEventListener("scroll", handleScroll);
    }

    return () => {
      const currentRef = shortContainerRef.current;
      if (currentRef) {
        currentRef.removeEventListener("scroll", handleScroll);
      }
    };
  }, [handleScroll]);

  return (
    <>
	  <DisablePostMessage />
      <section ref={shortContainerRef} className="short-container">
        {data.map((short) => (
          <Short
            key={short.id}
            shortContainerRef={shortContainerRef}
            short={short}
          />
        ))}
      </section>

      {loading && <div>Loading...</div>}

      <div className="navigation-container">
        <div
          onClick={() => {
            shortContainerRef.current.scrollTo(
              0,
              shortContainerRef.current.scrollTop - window.innerHeight
            );
          }}
          className="nav-up"
        >
          <ion-icon name="arrow-up-outline"></ion-icon>
        </div>
        <div
          onClick={() => {
            shortContainerRef.current.scrollTo(
              0,
              shortContainerRef.current.scrollTop + window.innerHeight
            );

          }}
          className="nav-down"
        >
          <ion-icon name="arrow-down-outline"></ion-icon>
        </div>
      </div>
    </>
  );
}

export default ShortContainer;
